import axios from "../interceptors/axios";

export default class TitleService {
  view = async (id) => {
    try {
      const response = await axios.get(`/api/titles/${id}/view`);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  };

  recordView = async (id) => {
    try {
      const response = await axios.post(`/api/titles/${id}/view`);
      return response.data;
    } catch (error) {
      // A falha da métrica não pode interromper a leitura do capítulo.
      return null;
    }
  };

  delete = async (params) => {
    try {
      const response = await axios.delete("/api/titles/delete", { params });
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  };

  edit = async (data) => {
    try {
      const response = await axios.post("/api/titles/edit", data, {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  };
}
